import { createContext, useContext } from "react";
import { SubNav } from "../../core/interfaces/SubNav";

export const SubNavContext = createContext<{
  setSubNav: (nav?: SubNav) => void;
}>({
  setSubNav: () => {},
});
export const useSubNav = () => useContext(SubNavContext);
